import {
    StyleSheet
} from "react-native";

export const ALERT_TITLE_VARIANT: keyof NCoreUIKit.Typography = "titleSmallSize";

const stylesheet = StyleSheet.create({
    title: {
        flexShrink: 1
    },
    compact: {
        flexGrow: 1
    }
});
export default stylesheet;
